<template>
  <div>
    <div class="user-info">
      <div class="beacon-id">
        <h2>{{ BeaconInfo }}</h2>
        <p>{{ date }}</p>
      </div>
      <div class="vertical-separator"></div>
      <div>
        <h2>{{ totalDuration }}</h2>
        <p>Total</p>
      </div>
      <div class="vertical-separator"></div>
      <div class="refresh-button" @click="refreshPage">
        <p>{{ $t('timesheet.refresh') }}</p>
        <img
          src="../assets/reload.svg"
          alt="reload"
          :height="20"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalDuration: {
      type: [String, Number],
      default: '_',
    },
    BeaconInfo: {
      type: String,
      default: 'AE-765-DF',
    },
    timeSheetStart: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      date: new Date().toLocaleDateString('fr'),
    };
  },
  watch: {
    timeSheetStart(nVal) {
      this.date = this.dateFormated(nVal);
    },
  },
  methods: {
    refreshPage() {
      window.location.reload();
    },
    dateFormated(ts) {
      const day = new Date(ts * 1000).getDate();
      const month = new Date(ts * 1000).getMonth() + 1;
      const year = new Date(ts * 1000).getFullYear();
      return `${day < 10 ? `0${day}` : day}/${month < 10 ? `0${month}` : month}/${year}`;
    },
  },
};
</script>

<style scoped>
  .user-info {
    display: flex;
    text-align: left;
    margin:12px;
  }

  .user-info * {
    margin: 0;
  }

  .beacon-id {
    max-width: 30%;
  }

  .beacon-id > h2 {
    overflow: auto;
  }

  .vertical-separator {
    margin: 0 12px 0 12px;
    border-right: 1px solid grey;
  }

  .glyphicon {
    margin-left: 4px;
  }

  .refresh-button {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    border: 1px solid grey;
    border-radius: 10px;
    width: 100%;
  }

  .refresh-button > span {
    font-size: 2rem;
  }
</style>
